var _excluded = ["steps", "onChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import StepButton from '@material-ui/core/StepButton';
import Step from '@material-ui/core/Step';
import MuiStepper from '@material-ui/core/Stepper';
import StepLabel from '@material-ui/core/StepLabel';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import StepIcon from './StepIcon';
import Heading from '../Heading';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      paddingTop: function paddingTop(_ref) {
        var isMobile = _ref.isMobile;
        return isMobile ? 12 : 0;
      },
      '& .MuiStepper-root': {
        paddingLeft: function paddingLeft(_ref2) {
          var isMobile = _ref2.isMobile;
          return isMobile ? 0 : null;
        },
        paddingRight: function paddingRight(_ref3) {
          var isMobile = _ref3.isMobile;
          return isMobile ? 0 : null;
        }
      },
      '& .MuiStepConnector-alternativeLabel': {
        top: 'auto',
        bottom: function bottom(_ref4) {
          var isMobile = _ref4.isMobile;
          return isMobile ? 15 : 25;
        },
        // padding: ({isMobile}) => (isMobile ? 0 : null),
        zIndex: 0
      },
      '& .MuiStepConnector-lineHorizontal': {
        borderWidth: '2px'
      },
      '& .MuiStepConnector-completed .MuiStepConnector-lineHorizontal': {
        borderColor: theme.palette.primary.main
      },
      '& .MuiStepper-alternativeLabel': {
        alignItems: 'flex-end'
      },
      '& .MuiStepButton-root': {
        paddingTop: function paddingTop(_ref5) {
          var isMobile = _ref5.isMobile;
          return isMobile ? 0 : null;
        }
      },
      '& .MuiStepLabel-alternativeLabel': {
        flexDirection: 'column-reverse',
        marginTop: theme.spacing(2),
        fontWeight: theme.typography.fontWeightMedium
      },
      '& .MuiStepLabel-alternativeLabel .Mui-error': {
        color: theme.palette.secondary.main
      },
      '& .MuiStepConnector-horizontal': {
        left: function left(_ref6) {
          var isMobile = _ref6.isMobile;
          return isMobile ? '-50%' : null;
        },
        right: function right(_ref7) {
          var isMobile = _ref7.isMobile;
          return isMobile ? '50%' : null;
        }
      },
      '& .MuiStepButton-touchRipple': {
        display: 'none'
      },
      // disabled state
      '& .MuiStepLabel-alternativeLabel:not(.Mui-error), & .MuiStep-alternativeLabel:not(.MuiStep-completed)': {
        '& .Mui-disabled .MuiStepLabel-iconContainer > div': {
          border: '1px solid rgba(236, 0, 140, 0.5)'
        },
        '& .Mui-disabled .MuiStepLabel-iconContainer > div > p': {
          color: 'rgba(236, 0, 140, 0.5)'
        }
      },
      '& .MuiStepLabel-alternativeLabel.Mui-error, & .MuiStepLabel-alternativeLabel.Mui-error.Mui-disabled': {
        '& .MuiStepLabel-iconContainer > div > p': {
          color: '#fff !important'
        }
      }
    }
  };
});
var Stepper = function Stepper(_ref8) {
  var steps = _ref8.steps,
    onChange = _ref8.onChange,
    rest = _objectWithoutPropertiesLoose(_ref8, _excluded);
  var _React$useState = React.useState(0),
    activeStep = _React$useState[0],
    setActiveStep = _React$useState[1];
  var handleStep = function handleStep(step) {
    return function () {
      setActiveStep(step);
      onChange(step);
    };
  };
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  });
  var classes = useStyles({
    isMobile: isMobile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, isMobile && /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    align: "center",
    gutterBottom: false
  }, steps[activeStep].label), /*#__PURE__*/React.createElement(MuiStepper, _extends({
    alternativeLabel: true,
    activeStep: activeStep
  }, rest, {
    style: {
      padding: isMobile ? '18px 0' : '5px 0px 24px 0px'
    }
  }), steps.map(function (_ref9, index) {
    var label = _ref9.label,
      error = _ref9.error,
      completed = _ref9.completed,
      disabled = _ref9.disabled;
    return /*#__PURE__*/React.createElement(Step, {
      key: label,
      completed: completed,
      disabled: !!disabled
    }, /*#__PURE__*/React.createElement(StepButton, {
      onClick: handleStep(index)
    }, /*#__PURE__*/React.createElement(StepLabel, {
      error: error,
      StepIconComponent: StepIcon
    }, !isMobile && label)));
  })));
};
Stepper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Array of step labels
   */
  steps: PropTypes.arrayOf(PropTypes.shape({
    optional: PropTypes.bool,
    label: PropTypes.string,
    error: PropTypes.bool,
    completed: PropTypes.bool,
    disabled: PropTypes.bool
  })).isRequired,
  /**
   * Function to trigger action when activeStep changes...
   */
  onChange: PropTypes.func
} : {};
Stepper.defaultProps = {
  onChange: function onChange() {
    return null;
  }
};
export default Stepper;